/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Pace_DescInputs */

const en_ui_color_by_pace_desc = /** @type {(inputs: Ui_Color_By_Pace_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z1–Z5 · map + pace chart`)
};

const de_ui_color_by_pace_desc = /** @type {(inputs: Ui_Color_By_Pace_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z1–Z5 · Karte + Pace-Chart`)
};

/**
* | output |
* | --- |
* | "Z1–Z5 · map + pace chart" |
*
* @param {Ui_Color_By_Pace_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_pace_desc = /** @type {((inputs?: Ui_Color_By_Pace_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Pace_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_pace_desc(inputs)
	return de_ui_color_by_pace_desc(inputs)
});